module.exports = __webpack_public_path__ + "img/button-hardware-disabled.d2ceb569.svg";